import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiCalendar } from 'react-icons/fi';

export const MenuItemDeadlines = (props: {
  course: ICourse,
  onCourseDeadlines: (course: ICourse) => void,
}) => {
 return <MenuItem icon={<FiCalendar />} onClick={() => props.onCourseDeadlines(props.course)} >Course Deadlines...</MenuItem>
}
